<template>
  <div class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/authors">Авторы</router-link>
          <span></span>
          <h1>Создание автора</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="folder radius">
          <div class="column caption">
            <p>Основные настройки</p>
          </div>
          <div class="column">
            <div class="content">
              <form-input name="title"></form-input>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onAddItem">Сохранить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FormInput from '@/components/create-form/Input'
  import FormTextArea from '@/components/create-form/TextArea'
  import FormFile from '@/components/create-form/File'
  import FormDropDown from '@/components/create-form/DropDown'
  import FormTextEditor from '@/components/create-form/TextEditor'
  import Checkbox from '@/components/create-form/Checkbox'
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('mainPage')

  export default {
    data: function () {
      return {
        editorInstance: '',
        isLoaded: false,
        text: '',
        editor: null,
        editorConfig: {
          language: 'ru',
          ckfinder: {
            uploadUrl: this.$store.state.apiDomain + this.$store.state.ckfinderUrl,
            token: localStorage.token
          }
        }
      }
    },
    computed: {
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId () {
        return this.$store.state.parentId
      },
      ...mapState([
        'textContent',
        'fields'
      ]),
    },
    methods: {
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev',
        'checkTabAwailability',
        'addToNews'
      ]),
      ...mapMutations([
        'setField',
        'resetTextEditor',
        'setTabs',
        'setCurrentTabId',
        'setFileExtensions',
        'setCurrentParentId',
        'setUrl'
      ]),
      onAddItem () {
        this.addItem().then(() => {
          this.$router.push('/authors')
        })
      },
    },
    created () {
      this.setUrl(this.apiUrls.content)
      this.setCurrentParentId(this.parentId.authors)
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Имя автора',
          errorId: null,
          errors: {empty: 'Введите имя автора'},
          tabId: 0
        },
        content_id: {
          value: null,
          parameterName: 'content_id',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        url: {
          value: '',
          parameterName: 'url',
          name: 'Ссылка',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
      })
    },
    components: {
      Checkbox,
      FormInput,
      FormTextArea,
      FormFile,
      FormDropDown,
      FormTextEditor,
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/authors/pages/Create.vue